module.exports = __webpack_public_path__ + "static/media/banner-login.8619d711.png";